import * as React from 'react'

import {
    useMediaQuery
} from '@mui/material'
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';

import Anima from '../../../../../assets/images/logosDepoimento/logo-anima-1024.png';
import NovosConceitos from '../../../../../assets/images/logosDepoimento/novos_conceitos.png';
import LZ from '../../../../../assets/images/logosDepoimento/LZ.png';
import ProBrasil from '../../../../../assets/images/logosDepoimento/pro.png';
import RadioLiberdade from '../../../../../assets/images/logosDepoimento/Logo-liberdade-radio-Belo-Horizonte.png';


import { Navigation, Pagination, Scrollbar, A11y, Autoplay  } from 'swiper/modules';

import { Swiper, SwiperSlide } from 'swiper/react';


import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import { BaseDiv, CardBody, CardContent, CardLogo, CardName, PrincipalDiv } from './styles'
import { useRef, useState } from 'react'
import { useIntersection } from 'react-use'


const CarrouselClientesFalam: React.FC = () => {
    const matches = useMediaQuery('(max-width:1000px)');
    const matches2 = useMediaQuery('(max-width:1300px)');
    const matches3 = useMediaQuery('(max-width:1600px)');
    const matches4 = useMediaQuery('(max-width:1400px)');
    const matchesSwipe = useMediaQuery('(max-width:900px)');
    const mobileMatch = useMediaQuery('(max-width:450px)');
    const swiperRef = useRef<any>(null);

    const carouselRef = useRef<HTMLDivElement>(null);

    const [isVisible, setIsVisible] = useState(false);

    const intersection = useIntersection(carouselRef, {
    root: null,
    rootMargin: '200px', // Ativa 200px antes de entrar no viewport
    threshold: 0.1, // Ativa quando 10% do elemento está visível
    });

    React.useEffect(() => {
    if (intersection?.isIntersecting) {
      setIsVisible(true);
      if (swiperRef.current) {
        swiperRef.current.autoplay?.start(); // Inicia o autoplay
      }
    } else {
      setIsVisible(false);
      if (swiperRef.current) {
        swiperRef.current.autoplay?.stop(); // Para o autoplay
      }
    }
  }, [intersection]);


    const dados = [
        {
          logo: RadioLiberdade,
          content:"O BHBUS Mídia é uma empresa com a qual eu sempre negocio para as nossas campanhas, em parceria com a equipe, escolheremos linhas estratégicas para eficácia da campanha.",
          content2:"Sempre contemplo a mídia em ônibus em nossos planos de mídia, considero um meio de excelente custo benefício e alcance.",
          name:"Juliana",
          grupo: "Rádio Liberdade"
        },
        {
            logo: Anima,
            content:"Mídia em ônibus nos traz o Impacto de um grande formato com a vantagem de uma cobertura maior. A capilaridade que as linhas entregam ampliam a cobertura de campanha para dentro dos balares e regões onde não temos opções OOH. Sem falhar da possibilidade de escolher linhas e definir o público a ser Impactado, segmentado por(região?) regiões.E sem dúvida o meio, dentro de leque de meios de OOH, que traz maior Impacto e cobertura.",
            content2:"Por sua vez, O BHBUS Mídia entrega profissionalismo e excelência na execução da mídia. Tenho plena confiança quando me orientam na seleção das linhas e também quando envio a arte para produção.",
            name:"Dani Carvalho",
            grupo: "Grupo Ânima"
        },
        {
            logo: NovosConceitos,
            content:"O Backbus está sempre presente em nossos planejamentos e ações de mídias para divulgação das campanhas, produtos e serviços de nossos clientes. O custo-benefício, a garantia da mensagem entregue para público alvo em cada cantinho de BH, a excelência do atendimento e parceria com o BHBUS Midia, são os Ingredientes e garantia de sucesso dessa receita.",
            name:"José Afonso Júnior",
            grupo: "Novos conceitos"
        },
    ]

    return (
        <BaseDiv id="dep">
          <PrincipalDiv
            ref={carouselRef}
          >
            <h1
              style={{
                fontSize: '2.8rem',
                color: 'black',
                paddingBottom: '30px',
                margin: 0,
                marginBottom: '2rem',
                fontFamily: 'Montserrat sans-serif',
              }}
              className='clientesTitle'
            >
              O QUE OS NOSSOS CLIENTES DIZEM SOBRE NÓS:
            </h1>
              <CardBody>
                {dados.map((data: any, index: number) => (
                  <CardContent>
                    <p>
                      <FormatQuoteIcon
                        style={{
                          display: 'flex',
                          justifyContent: 'left',
                          transform: 'rotateY(180deg)',
                          marginLeft: '5px',
                        }}
                      />
                      {data?.content}
                    </p>
                    <p>
                      {data?.content2}
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'right',
                        }}
                      >
                        <FormatQuoteIcon />
                      </div>
                    </p>
                    <CardLogo>
                      <img
                        src={data?.logo}
                        width={mobileMatch ? 70 : matches ? 80 : 100}
                        style={{ maxHeight: mobileMatch ? 50 : matches ? 60 : 75 }}
                      />
                    </CardLogo>
                    <CardName>{data?.name}</CardName>
                    <CardName className='grupo' style={{color: '#a1a1a1' }}>{data?.grupo}</CardName>
                  </CardContent>
                ))}
              </CardBody>
          </PrincipalDiv>
        </BaseDiv>
      );
    };

export { CarrouselClientesFalam }